import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { style } from './sticky-bar.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


export const stickyBarPositions = ['bottom', 'top'] as const
export type stickyBarPositionsType = typeof stickyBarPositions

@customElement('cse-sticky-bar')
export class CSEStickyBar extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  override render() {
    return html`
      <slot class="cse-sticky-bar"></slot>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-sticky-bar': CSEStickyBar
  }
}
